import { isAxiosError, type AxiosError } from 'axios';

/**
 * Upgrade required
 */
export function is402Status(error: unknown): boolean {
  return isErrorCode(error, 402);
}

/**
 * Login Required
 */
export function is401Status(error: unknown): boolean {
  return isErrorCode(error, 401);
}

export function isErrorCode(error: unknown, code: number): boolean {
  return (
    isAxiosError(error) &&
    typeof (error as AxiosError).response === 'object' &&
    (error as AxiosError).response?.status === code
  );
}

export function isCanceledNetworkRequest(error: unknown): boolean {
  return (
    isAxiosError(error) &&
    typeof (error as AxiosError).response === 'object' &&
    (error as AxiosError).response?.status === 20
  );
}

export function getAxiosErrorMessage(error: unknown): string {
  return isAxiosError(error)
    ? (error.response?.data?.message || error.message || '').toString()
    : '';
}
